import React, { useEffect, useState, useMemo } from 'react'
import { useTranslate, useNotify, required, Form, Create } from 'react-admin'
import { Box, Container, Skeleton, Typography, Grid, TextField, Divider, ToggleButtonGroup, ToggleButton, Button, CircularProgress, Dialog, DialogContent, DialogTitle, DialogActions, Autocomplete } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { billingFormServices } from 'src/services/payment/billingForm/billingForm.service';
import { useBillingContext } from 'src/components/pages/payment/billing-form/context/billingContext'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { paymentServices } from 'src/services/payment/Payment.service'
import PaymentModal from './paymentModal';
import ReservationModal from './reservationModal';
import ConfirmationModal from './confirmationModal';
import ItemsModal from './itemsModal';
import CurrencyInput from 'src/components/uiElements/fields/CurrencyInput'
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { hasPermissionFunction } from 'src/helper/HasPermission';
import { Search } from '@mui/icons-material'

function CustomDivider(content) {
  return (
    <Box display="flex" alignItems="center" sx={{ width: '98%', margin: '15px 0 auto 15px' }}>
      <Typography variant="body1" sx={{ mr: 2, color: '#a9afc8', fontWeight: 'bold' }}>
        {content}
      </Typography>
      <Divider sx={{ flexGrow: 1, borderBottomWidth: 2, borderColor: 'rgba(222,222,222,255)' }} />
    </Box>
  );
}


function BillingRegister() {
  const translate = useTranslate()
  const notify = useNotify()
  const [businessUnits, setBusinessUnits] = useState([])
  const [username, setUsername] = useState(null)
  const [businessName, setBusinessName] = useState(null)
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState(null)
  const [loadingBusinessUnits, setLoadingBusinessUnits] = useState(false)
  const [loadingPaymentTypes, setLoadingPaymentTypes] = useState(false)
  const [isLoading, setIsLoading] = useState([])
  const [reservationsList, setReservationsList] = useState([])
  const [reservationsSelectedList, setReservationsSelectedList] = useState([])
  const [isEnabled, setIsEnabled] = useState(false)
  const [user, setUser] = useState([])
  const [banks, setBanks] = useState([])
  const [cards, setCards] = useState([])
  const [currencies, setCurrencies] = useState([])
  const [cash, setCash] = useState([])
  const [paymentTypes, setPaymentTypes] = useState([])
  const [errors, setErrors] = useState({});
  const [openModalPayment, setOpenModalPayment] = useState(false);
  const [openModalReservations, setOpenModalReservations] = useState(false);
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [openModalItems, setOpenModalItems] = useState(false);
  const [clients, setClients] = useState([])
  const [searchBy, setSearchBy] = useState(null)
  const [timeoutClients, setTimeoutClients] = useState()
  const [loadingClients, setLoadingClients] = useState(false)
  const [businessUnitSelect, setBusinessUnitSelect] = useState(null)
  const { paymentData, setPaymentData } = useBillingContext() //todo el form
  const initialPaymentData = useMemo(() => ({ ...paymentData }), []);
  const [totalPayments, setTotalPayments] = useState(0);
  const [totalReservations, setTotalReservations] = useState(0);
  const [saldo, setSaldo] = useState(0);
  const [selectedReservation, setSelectedReservation] = useState(null);
  const [base, setBase] = useState(null);
  const [openModalError, setOpenModalError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const paymentFieldLabels = {
    payment_type: translate('ra.field.operation_type'),
    bank_info: translate('ra.field.bank'),
    document_number: translate('ra.field.document_number'),
    customer_name: translate('ra.field.customer_name'),
    card_info: translate('ra.field.card'),
    card_number: translate('ra.field.last_digit_card'),
    expiry_date: translate('ra.field.expiry_date'),
    quota: translate('ra.field.quota'),
    coupon_number: translate('ra.field.coupon_number'),
    auth_code: translate('ra.field.auth_code'),
    payment_date: translate('ra.field.payment_date'),
    payment_id: translate('ra.field.payment_id'),
    amount: translate('ra.field.amount'),
    cash_info: translate('ra.entity.cash'),
    currency_info: translate('ra.field.currency'),
    check_type: translate('ra.field.check_type'),
    retentions: translate('ra.field.retentions'),
    date_emision: translate('ra.field.date_emision'),
    payer_CUITCUIL: translate('ra.field.payer_CUITCUIL'),
  };

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem('user')))
    setIsEnabled(true)
    setLoadingBusinessUnits(true)
  }, [])

  /* const allBusinessUnits = useQuery('business-unit-all', () => businessUnitServices.getByOrderParentCompress(), {
    enabled: isEnabled,
    onSuccess: () => {
      setIsEnabled(false)
    },
  }) */

  const onChangeClient = (value) => {
    clearTimeout(timeoutClients)
    if (value && searchBy) {
      const timeout = setTimeout(async () => {
        setLoadingClients(true)
        let params = {}
        if (isNaN(value)) {
          params[searchBy] = value
        } else {
          params['id'] = value
        }
        try {
          const response = await businessUnitServices.business_unit_filter(params)
          setClients(response)
        } catch (error) {
          setClients([])
        } finally {
          setLoadingClients(false)
        }
      }, 1000)
      setTimeoutClients(timeout)
    } else {
      setClients([])
    }
  }

  const handleInput = (event) => {
    if (searchBy === 'id') {
      const value = event.target.value
      // sacar caracteres que no sean números
      const numericValue = value.replace(/[^0-9]/g, '')
      if (value !== numericValue) {
        event.target.value = numericValue
        event.preventDefault()
      }
    }
  }

  const onChangeSelectedClient = (client) => {
    onChangeBusinessUnit(client.id)
    setBusinessUnitSelect(client.id)
  }


  const showKeys = (business_unit) => {
    let string = ''
    const business_name = business_unit?.fiscal_data_relation?.name || business_unit?.fiscal_data_name
    const fantasy_name = business_unit?.fantasy_name
    const long_name = business_unit?.long_name

    if (business_name) {
      string += '(RS) ' + business_name
    }
    if (fantasy_name) {
      string += (business_name ? ' - (NF) ' : '') + fantasy_name
    }
    if (long_name) {
      string += (business_name || fantasy_name ? ' - (NL) ' : '') + long_name
    }

    return string
  }

  const setBusinessUnitsClients = () =>{
      const mappedBusinessUnits = clients.map((unit) => {
      return ({
        id: unit.id,
        long_name: unit.long_name || 'N/A',  // Puedes manejar valores nulos si es necesario
        show_text: unit.id + ' - ' + unit.long_name || 'N/A',
        email: unit.email || 'N/A',
        work_unit: {hash_work_unit:unit.hash_work_unit, work_unit_token:unit.work_unit_token, work_unit_long_name:unit.work_unit_long_name, work_unit_id:unit.work_unit_id},
        hash_business_unit: unit.hash_business_unit || null,
        token: unit.token || null
      })}).sort((a, b) => a.long_name?.localeCompare(b.long_name));
      setLoadingBusinessUnits(false)
      setBusinessUnits(mappedBusinessUnits);
  }
  
  useEffect(() => {
    if (clients) {
      setBusinessUnitsClients()
    }
  }, [clients]);

  useEffect(() => {
    // Solo se ejecuta si hay un solo elemento en businessUnits
    if (businessUnits && businessUnits.length === 1) {
      const simulatedEvent = {
        target: {
          value: businessUnits[0].id, // O el id que necesites
        },
      };
      onChangeBusinessUnit(simulatedEvent); // Llama a onChangeBusinessUnit
    }
  }, [businessUnits]);


  const onChangeBusinessUnit = async (e) => {
    const businessUnitId = e;
    setLoadingPaymentTypes(true)
    if (businessUnitId && businessUnits?.length > 0) {
      const businessUnitMap = new Map(businessUnits.map(unit => [unit.id, unit]));  // Crear el Map aquí
      const selectedBusinessUnit = businessUnitMap.get(Number(businessUnitId));
      if (selectedBusinessUnit) {
        const email = selectedBusinessUnit.email;
        const longName = selectedBusinessUnit.long_name;
        setSelectedBusinessUnit(selectedBusinessUnit);
        setUsername(email);  // Actualizar el estado con el email
        setBusinessName(longName);
        setPaymentData({
          ...paymentData,
          business_unit_info: {
            id: businessUnitId,
            long_name: selectedBusinessUnit.long_name,
            token: selectedBusinessUnit.token,
            hash_business_unit: selectedBusinessUnit.hash_business_unit
          },
          payments: [],
          reservations_info: [],
          user_info: {
            id: user.user_id,
            name: user.name,
            surname: user.surname,
            email: user.email,
            hash_user: user.hashuser,
          },
          work_unit_info: {
            id: selectedBusinessUnit.work_unit.work_unit_id,
            long_name: selectedBusinessUnit.work_unit.work_unit_long_name,
            token: selectedBusinessUnit.work_unit.work_unit_token,
            hash_work_unit: selectedBusinessUnit.work_unit.hash_work_unit
          }
        });
        setTotalReservations(0)
        try {
          await Promise.all([
            getPaymentTypesByWorkUnit(selectedBusinessUnit.work_unit),
            getBankByWorkUnit(selectedBusinessUnit.work_unit),
            getCards(selectedBusinessUnit.work_unit),
            getCurrenciesByBusinessUnitById(businessUnitId),
            getCashByWorkUnit(selectedBusinessUnit.work_unit),
            getBaseByBusinessUnitById(businessUnitId)
          ]);
        } catch (error) {
          console.error(
            'Error fetching getCurrenciesByBusinessUnitById and getExchangeByBusinessUnitById',
            error
          );
        }
      }
    }
  };

  const getPaymentTypesByWorkUnit = async (work_unit) => {
    try {
      if (work_unit.hash_work_unit) {
        const allPaymentTypes = await paymentServices.getPaymentTypesByWorkUnit(work_unit.hash_work_unit)
        if (allPaymentTypes) {
          const filteredPaymentTypes = allPaymentTypes
            .filter(elem => elem.payment_type_relation.long_name !== "Retenciones" &&
              elem.payment_type_relation.long_name !== "Braspag" &&
              elem.payment_type_relation.long_name !== "AUTP" &&
              hasPermissionFunction('billingform', elem.payment_type_relation.short_name.toLowerCase()))
            .map(elem => elem.payment_type_relation)
            .sort((a, b) => a.long_name.localeCompare(b.long_name))
          setPaymentTypes(filteredPaymentTypes);
          setLoadingPaymentTypes(false)
        }
      }
    } catch (error) {
      setPaymentTypes([])
    }
  }

  const getCashByWorkUnit = async (work_unit) => {
    try {
      if (work_unit.hash_work_unit) {
        const allCash = await paymentServices.getCashByByWorkUnit(work_unit.hash_work_unit)
        if (allCash) {
          allCash.sort((a, b) => a.name.localeCompare(b.name))
          setCash(allCash)
        }
      }
    } catch (error) {
      setCash([])
    }
  }

  const getBankByWorkUnit = async (work_unit) => {
    try {
      const banks = await paymentServices.getBankByWorkUnitParents(work_unit.hash_work_unit);
      if (banks) {
        banks.sort((a, b) => a.name.localeCompare(b.name))
        setBanks(banks)
        return
      }
      setBanks([])
    } catch (error) {
      setBanks([])
    }
  }

  const getCards = async (work_unit) => {
    try {
      const response = await paymentServices.getPaymentMethodByWorkUnit(work_unit.work_unit_token);
      if (response) {
        // Extraer y filtrar tarjetas únicas
        const uniqueCards = [];
        const cardIds = new Set();

        response.forEach(item => {
          item.cards.forEach(card => {
            if (!cardIds.has(card.id)) {
              uniqueCards.push(card);
              cardIds.add(card.id);
            }
          });
        })
        uniqueCards.sort((a, b) => a.long_name.localeCompare(b.long_name));
        setCards(uniqueCards);
        return;
      }
      notify(`Card not found`, { type: 'error' });
    } catch (error) {
      notify(`Please, refresh page`, { type: 'error' });
    }
  };

  const getCurrenciesByBusinessUnitById = async (selectedBusinessUnitId) => {
    try {
      if (!selectedBusinessUnitId) {
        notify('ra.message.has_not_business_unit_to_get_currencies', {
          type: 'error',
        })
        setCurrencies([])
        return
      }
      const payment_currencies = await businessUnitServices.currencies_by_business_unit(selectedBusinessUnitId)
      if (payment_currencies) {
        payment_currencies.sort((a, b) => a.long_name.localeCompare(b.long_name));
        setCurrencies(payment_currencies)
      } else {
        notify('ra.message.has_not_currencies_by_business_unit', {
          type: 'error',
        })
        setCurrencies([])
      }
    } catch (error) {
      notify('ra.message.has_not_currencies_by_business_unit', {
        type: 'error',
      })
      setCurrencies([])
    } finally {
    }
  }

  const getBaseByBusinessUnitById = async (selectedBusinessUnitId) => {
    try {
      if (!selectedBusinessUnitId) {
        notify('ra.message.has_not_business_unit_to_get_currencies', {
          type: 'error',
        })
        setBase(null)
        return
      }
      const base = await reservationServices.getAllBases(selectedBusinessUnitId)
      if (base) {
        setBase(base.selected)
      } else {
        notify('ra.message.has_not_currencies_by_business_unit', {
          type: 'error',
        })
        setBase(null)
      }
    } catch (error) {
      notify('ra.message.has_not_currencies_by_business_unit', {
        type: 'error',
      })
      setBase(null)
    } finally {
    }
  }

  const getLongNamePaymentTypeById = (id) => {
    const method = paymentTypes.find(method => method.id === id);
    return method ? method.long_name.toLowerCase() : null;
  };

  function formatDate(isoDate) {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  const handleSavePayment = async (paymentDataForm) => {
    if (paymentDataForm && paymentDataForm.retentions && paymentDataForm?.retentions.length > 0) {
      try {
        let cotizacion = 1
        if (paymentDataForm.currency_info.short_name !== 'ARS') {
          const isoDate = paymentDataForm.payment_date;
          const formattedDate = formatDate(isoDate);
          let query = `base=${base}&created_at=${formattedDate}&currency_from=ARS&currency_to=${paymentDataForm.currency_info.short_name}&work_unit_hash=${paymentData?.work_unit_info?.hash_work_unit}&last_unique=true`;
          const currencyBase = await billingFormServices.getCurrencyBaseRelations(query);
          if (!currencyBase?.data[0]) {
            setErrorMessage(
              <>
                {translate('ra.message.paymentRegistrationExchangeRateError')}                
                {new Date(paymentDataForm.payment_date).toLocaleDateString('es-ES')}.
                <br />
                {translate('ra.message.contactSupportMessage')}   
              </>
            );
            setOpenModalError(true);
            return;
          }
          cotizacion = currencyBase.data[0].is_reverse ? currencyBase.data[0].value_reverse : currencyBase.data[0].value;
        }
        const totalRetentionsAmount = paymentDataForm.retentions.reduce((total, retention) => {
          const cleanAmount = parseFloat(retention.amount.replace(/\./g, '').replace(',', '.')) || 0;
          return total + cleanAmount;
        }, 0);

        const adjustedTotal = totalRetentionsAmount * cotizacion;
        const totalRetentionNode = {
          type: "Total Retenciones",
          amount: adjustedTotal.toFixed(2),
          certificate: null,
          files: []
        };
        paymentDataForm.retentions = [...paymentDataForm.retentions, totalRetentionNode];
        paymentDataForm.currency_info.retention_value = cotizacion;
      } catch (error) {
        console.error("Error al obtener las bases:", error);
      }
    }

    setPaymentData((prevData) => ({
      ...prevData,
      payments: prevData.payments ? [...prevData.payments, paymentDataForm] : [paymentDataForm]
    }));
  };

  useEffect(() => {
    if (paymentData?.payments && paymentData?.payments.length > 0) {
      const totalAmount = paymentData.payments.reduce((acc, payment) => {
        let paymentTotal = payment.amount || 0;

        if (payment.retentions && payment.retentions.length > 0) {
          const totalRetentionNode = payment.retentions.find(
            (retention) => retention.type === "Total Retenciones"
          );
          if (totalRetentionNode) {
            paymentTotal += parseFloat(totalRetentionNode.amount) || 0;
          }
        }

        return acc + paymentTotal;
      }, 0);

      setTotalPayments(totalAmount);
    } else {
      setTotalPayments(0)
      setTotalReservations(0)
      setSaldo(0)
      setPaymentData({
        ...paymentData,
        reservations_info: []
      });
    }
  }, [paymentData.payments]); // Escucha los cambios en paymentData

  const handleDeletePayment = (index) => {
    const updatedPayments = paymentData.payments.filter((_, i) => i !== index);
    setPaymentData(prevState => ({
      ...prevState,
      payments: updatedPayments,
    }));
  };

  const roundToTwo = (num) => Math.round(num * 100) / 100;

  const handleOptionChangeRadio = (reservationId, newStatus) => {
    if (!newStatus) return; // Si newStatus es null o undefined, no hacer nada

    setPaymentData((prevPaymentData) => {
      const updatedReservations = prevPaymentData.reservations_info.flat().map((reservation) => {
        if (reservation.id === reservationId) {
          if (reservation.status_payment === newStatus) {
            return reservation;
          }
          // Lógica para actualizar el estado y el payment_amount
          let pending_amount = reservation.destination_prices.pending_amount;
          let payment_amount_reservation = reservation.payment_amount || 0;
          if (newStatus === 'Total') {
            setTotalReservations((prevTotal) => roundToTwo(prevTotal + pending_amount - payment_amount_reservation));
          } else {
            setTotalReservations((prevTotal) => roundToTwo(prevTotal - pending_amount));
          }
          const updatedPaymentAmount = newStatus === 'Total' ? 0 : reservation.payment_amount;
          const updatedPaymentAmountDisplay = newStatus === 'Total' ? 0 : reservation.payment_amount_display;
          return {
            ...reservation,
            status_payment: newStatus,
            payment_amount: updatedPaymentAmount,
            payment_amount_display: updatedPaymentAmountDisplay
          };
        }
        return reservation;
      });

      return {
        ...prevPaymentData,
        reservations_info: updatedReservations,
      };
    });
  };

  const handlePaymentAmountChange = (reservationId, newAmount) => {
    const amount_payment = newAmount === '' ? 0 : parseFloat(newAmount.replace(/\./g, '').replace(',', '.'));
    setPaymentData((prevPaymentData) => {
      const updatedReservations = prevPaymentData.reservations_info.flat().map((reservation) => {
        if (reservation.id === reservationId) {
          const previousAmount = reservation.payment_amount || 0;
          // Actualizar el total cuando está en "Parcial"
          if (reservation.status_payment === 'Parcial') {
            setTotalReservations((prevTotal) => roundToTwo(prevTotal - previousAmount + amount_payment));
          }

          return {
            ...reservation,
            payment_amount: amount_payment, // Actualiza el payment_amount
            payment_amount_display: newAmount,
            error: false
          };
        }
        return reservation;
      });

      return {
        ...prevPaymentData,
        reservations_info: updatedReservations,
      };
    });
  };

  const handleSaveReservations = (reservationsDataForm) => {
    setPaymentData((prevData) => {
      // Filtrar las nuevas reservas eliminando aquellas que ya existen en prevData.reservations
      const newReservations = reservationsDataForm.filter((newRes) => {
        return !prevData.reservations_info?.some((existingRes) => existingRes.id === newRes.id);
      });

      const updatedReservations = prevData.reservations_info
        ? [...prevData.reservations_info, ...newReservations]
        : [...newReservations];

      // Calcular el nuevo total de pending_amount solo para las nuevas reservas
      const newTotalReservations = newReservations.reduce((acc, reservation) => {
        return roundToTwo(acc + reservation.destination_prices.pending_amount); // Redondear a 2 decimales
      }, 0);

      // Actualiza el total acumulado solo con el nuevo total
      setTotalReservations((prevTotal) => roundToTwo(prevTotal + newTotalReservations));

      return {
        ...prevData,
        reservations_info: updatedReservations
      };
    });
  };

  const handleDeleteReservation = (reservationId) => {
    const reservationToDelete = paymentData.reservations_info.find((reservation) => reservation.id === reservationId);

    let payment_amount_reservation = reservationToDelete.payment_amount || 0;
    const amountToSubtract = reservationToDelete.status_payment === 'Parcial'
      ? payment_amount_reservation
      : reservationToDelete.destination_prices.pending_amount || reservationToDelete.destination_prices.pending_amount;

    const updatedReservations = paymentData.reservations_info.filter((reservation) => reservation.id !== reservationId);

    // Actualizar el total después de eliminar la reserva y redondear
    setTotalReservations((prevTotal) => roundToTwo(prevTotal - amountToSubtract));

    setPaymentData(prevState => ({
      ...prevState,
      reservations_info: updatedReservations,
    }));
  };

  const handleConfirmReservations = () => {
    let hasErrors = false;
    let messageError = ''

    if (Math.round(saldo * 100)/100 !== 0) {
      hasErrors = true;
      if (saldo > 0) {
        messageError = translate('ra.message.pending_amount_error')
      } else {
        messageError = translate('ra.message.allocation_amount_error')
      }
    }

    let updatedReservations = paymentData.reservations_info.flat().map((reservation) => {
      if (reservation.status_payment === 'Parcial' && (!reservation.payment_amount || reservation.payment_amount <= 0)) {
        // Si está en "Parcial" y el monto es 0 o no está definido, marcar error
        reservation.error = true;
        hasErrors = true;
        messageError = 'Error: Debes completar los otros importes para la imputación.'
      } else {
        reservation.error = false; // Resetear error si está correcto
      }
      return reservation;
    });

    if (hasErrors) {
      // Mostrar errores, no abrir el modal
      setPaymentData((prevData) => ({
        ...prevData,
        reservations_info: updatedReservations,
      }));
      notify(messageError, { type: 'error' });
      return;
    }

    // Si no hay errores, abrir el modal de confirmación
    setOpenModalConfirmation(true);
  };

  const sendForm = () => {
    setPaymentData(initialPaymentData);
    setUsername(null)
    setBusinessName(null)
    return;
  }

  useEffect(() => {
    setSaldo(totalPayments - totalReservations);
  }, [totalPayments, totalReservations]);

  const handleOpenItems = (reservation) => {
    setSelectedReservation(reservation); // Guarda la reserva seleccionada
    setOpenModalItems(true); // Abre el modal
  };

  const onTransform = (values) =>{
    return {...values, business_unit:businessUnitSelect}
  }

  return (
    <Container >
      <CardCommon title={translate('ra.entity.payment-entity')} style={{ border: '1px solid rgba(0, 0, 0, 0.3)', boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.2)' }}>
        <Create transform={onTransform}>
          <Form id='post_create_form' record={paymentData}>
            <Grid container className='payment-register' style={{justifyContent:'end'}}>
              <EditInputsWrap md={3} lg={3} label={translate('ra.field.search_by')}>
                <Autocomplete
                  size='small'
                  options={[
                    {
                      id: 'fantasy_name__ilike',
                      name: translate('ra.field.fantasy_name'),
                    },
                    {
                      id: 'fiscal_data__name__ilike',
                      name: translate('ra.field.business_name'),
                    },
                    {
                      id: 'long_name__ilike',
                      name: translate('ra.field.long_name'),
                    },
                    {
                      id: 'id',
                      name: translate('ra.field.id'),
                    },
                  ]}
                  renderInput={(params) => <TextField {...params} label='' />}
                  getOptionLabel={(option) => option.name}
                  noOptionsText={translate('ra.validation.noOptionsText')}
                  placeholder={translate('ra.field.search_by')}
                  onChange={(e, value) => {
                    setSearchBy(value?.id)
                    setClients([])
                  }}
                />
              </EditInputsWrap>
              <EditInputsWrap md={9} lg={9} className='input-gray'>
                <Autocomplete
                  size='small'
                  options={clients || []}
                  getOptionLabel={(option) => showKeys(option)}
                  loading={loadingClients}
                  loadingText={translate('ra.action.loading')}
                  filterOptions={() => clients}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={translate('ra.field.search_client')}
                      onChange={(e) => onChangeClient(e.target.value)}
                      onInput={handleInput}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: <Search />,
                        endAdornment: (
                          <>
                            {loadingClients ? <CircularProgress color='inherit' size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  onChange={(e, value) => onChangeSelectedClient(value)}
                  noOptionsText={translate('ra.validation.noOptionsText')}
                  placeholder={translate('ra.field.search_client')}
                  disabled={!searchBy}
                />
              </EditInputsWrap>
              {/* <EditInputsWrap label={translate('ra.field.business_unit')} md={6} lg={6} xs={12} required>
                {loadingBusinessUnits ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    size='small'
                    source='business_unit'
                    options={businessUnits}
                    label=''
                    optionsText={['show_text']}
                    separator=' - '
                    optionValue='id'
                    onChange={onChangeBusinessUnit}
                    showSearch
                    validate={[required()]}
                    defaultValue={
                      paymentData?.business_unit_info?.id ? paymentData?.business_unit_info?.id : null
                    }
                  />
                )}
              </EditInputsWrap> */}

              {/* <EditInputsWrap label={translate('ra.field.username')} md={4} lg={4} xs={12} >
                <TextField size='small' fullWidth disabled value={username || ''} />
              </EditInputsWrap> */}

              <EditInputsWrap label={translate('ra.field.business_name')} md={6} lg={6} xs={12} >
                <TextField size='small' fullWidth disabled value={businessName || ''} />
              </EditInputsWrap>

              <EditInputsWrap label={translate('ra.field.username')} md={6} lg={6} xs={12} >
                <TextField size='small' fullWidth disabled value={username || ''} />
              </EditInputsWrap>
            </Grid>

            {paymentData?.business_unit_info && (
              <>

                {CustomDivider(translate('ra.title.payment_info'))}
                {paymentData?.payments && paymentData?.payments?.length !== 0 &&
                  paymentData.payments.map((payment, index) => (
                    <Grid item xs={12} md={6} lg={4} key={index}>
                      <Paper
                        sx={{
                          padding: '15px',
                          border: '1px solid rgb(174, 180, 203)',
                          backgroundColor: '#f8f8f8',
                          borderRadius: '8px',
                          boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.1)',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '10px',
                          margin: '25px 15px',
                        }}
                      >
                        <Grid container spacing={1}>
                          {/* Información básica del pago */}
                          {payment.amount && (
                            <Grid item xs={12} sm={6}>
                              <Typography variant="subtitle2">{paymentFieldLabels.amount}:</Typography>
                              <Typography variant="body2">
                                {payment.currency_info.short_name}{" "}
                                {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(payment.amount))}
                              </Typography>
                            </Grid>

                          )}
                          {/* Información de retentions */}
                          {payment.retentions && (
                            <Grid item xs={12} sm={6}>
                              <Typography variant="subtitle2">{paymentFieldLabels.retentions}:</Typography>
                              <Typography variant="body2">{payment.retentions.length > 0 ? 'Sí' : 'No'}</Typography>
                            </Grid>
                          )}
                          {payment.payment_type && (
                            <Grid item xs={12} sm={6}>
                              <Typography variant="subtitle2">{paymentFieldLabels.payment_type}:</Typography>
                              <Typography variant="body2">{payment.payment_type.toUpperCase()}</Typography>
                            </Grid>
                          )}
                          {payment.retentions && payment.retentions.length > 0 && (
                            <Grid item xs={12} sm={6}>
                              <Typography variant="subtitle2">Total {paymentFieldLabels.retentions}:</Typography>
                              <Typography variant="body2">
                                {(() => {
                                  const totalRetentionNode = payment.retentions.find(
                                    (retention) => retention.type === "Total Retenciones"
                                  );
                                  return totalRetentionNode
                                    ? `${payment.currency_info.short_name} ${new Intl.NumberFormat('es-AR', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }).format(parseFloat(totalRetentionNode.amount))}`
                                    : 'No especificado';
                                })()}
                              </Typography>
                            </Grid>
                          )}
                          {payment.payment_date && (
                            <Grid item xs={12} sm={6}>
                              <Typography variant="subtitle2">{paymentFieldLabels.payment_date}:</Typography>
                              <Typography variant="body2">
                                {new Date(payment.payment_date).toLocaleDateString('es-ES')}
                              </Typography>
                            </Grid>
                          )}
                          {/* Información de bank_info */}
                          {payment.bank_info && (
                            <Grid item xs={12}>
                              <Typography variant="subtitle2">{paymentFieldLabels.bank_info}:</Typography>
                              <Typography variant="body2">{payment.bank_info.name}</Typography>
                              {payment.bank_info.document_number && (
                                <>
                                  <Typography variant="subtitle2">{paymentFieldLabels.payer_CUITCUIL}:</Typography>
                                  <Typography variant="body2">{payment.bank_info.document_number}</Typography>
                                </>
                              )}
                              {payment.bank_info.coupon_number && (
                                <>
                                  <Typography variant="subtitle2"> {paymentFieldLabels.coupon_number}:</Typography>
                                  <Typography variant="body2">{payment.bank_info.coupon_number}</Typography>
                                </>
                              )}
                            </Grid>
                          )}

                          {/* Información de card_info */}
                          {payment.card_info && (
                            <Grid item xs={12}>
                              <Typography variant="subtitle2">{paymentFieldLabels.card_info}:</Typography>
                              <Typography variant="body2">{payment.card_info.long_name}</Typography>
                              <Typography variant="subtitle2">{paymentFieldLabels.customer_name}:</Typography>
                              <Typography variant="body2">{payment.card_info.customer_name}</Typography>
                              <Typography variant="subtitle2">{paymentFieldLabels.card_number}:</Typography>
                              <Typography variant="body2">{payment.card_info.card_number}</Typography>
                              <Typography variant="subtitle2">{paymentFieldLabels.expiry_date}:</Typography>
                              <Typography variant="body2">
                                {new Date(payment.card_info.expiry_date).toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit' })}
                              </Typography>
                              <Typography variant="subtitle2">{paymentFieldLabels.quota}:</Typography>
                              <Typography variant="body2">{payment.card_info.quotes}</Typography>
                              <Typography variant="subtitle2">{paymentFieldLabels.coupon_number}:</Typography>
                              <Typography variant="body2">{payment.card_info.coupon_code}</Typography>
                              <Typography variant="subtitle2">{paymentFieldLabels.auth_code}:</Typography>
                              <Typography variant="body2">{payment.card_info.auth_code}</Typography>
                            </Grid>
                          )}

                          {/* Información de card_info */}
                          {payment.wallet_info && (
                            <Grid item xs={12}>
                              <Typography variant="subtitle2">{paymentFieldLabels.payment_id}:</Typography>
                              <Typography variant="body2">{payment.wallet_info.payment_id}</Typography>
                            </Grid>
                          )}
                          {payment.cash_info && (
                            <Grid item xs={12}>
                              <Typography variant="subtitle2">{paymentFieldLabels.cash_info}:</Typography>
                              <Typography variant="body2">{payment.cash_info.code}</Typography>
                              <Typography variant="subtitle2">{paymentFieldLabels.customer_name}:</Typography>
                              <Typography variant="body2">{payment.cash_info.customer_name}</Typography>
                            </Grid>
                          )}
                          {payment.check_info && (
                            <Grid item xs={12}>
                              <Typography variant="subtitle2">{paymentFieldLabels.bank_info}:</Typography>
                              <Typography variant="body2">{payment.check_info.bank_name}</Typography>
                              <Typography variant="subtitle2">{paymentFieldLabels.check_type}:</Typography>
                              <Typography variant="body2">{payment.check_info.type}</Typography>
                              {payment.check_info.type === 'diferido' &&
                                <>
                                  <Typography variant="subtitle2">{paymentFieldLabels.date_emision}:</Typography>
                                  <Typography variant="body2">{new Date(payment.check_info.date_emision).toLocaleDateString('es-ES')}</Typography>
                                </>
                              }
                              <Typography variant="subtitle2">{paymentFieldLabels.coupon_number}:</Typography>
                              <Typography variant="body2">{payment.check_info.coupon_number}</Typography>
                              <Typography variant="subtitle2">{paymentFieldLabels.customer_name}:</Typography>
                              <Typography variant="body2">{payment.check_info.customer_name}</Typography>
                              <Typography variant="subtitle2">{paymentFieldLabels.payer_CUITCUIL}:</Typography>
                              <Typography variant="body2">{payment.check_info.document_number}</Typography>
                            </Grid>
                          )}

                        </Grid>
                        <Typography
                          variant="body2"
                          sx={{ cursor: 'pointer', color: '#ee9c2d', textAlign: 'right', alignSelf: 'flex-end' }}
                          onClick={() => handleDeletePayment(index)}
                        >
                          <b> {translate('ra.action.deleteRecord')} </b>
                        </Typography>
                      </Paper>
                    </Grid>
                  ))}

                {(
                  (!paymentData?.payments || paymentData?.payments.length === 0) ||
                  (paymentData.payments.length > 0 &&
                    ['transferencia bancaria', 'deposito bancario'].includes(
                      getLongNamePaymentTypeById(paymentData.payments[paymentData.payments.length - 1].payment_method_id)
                    ))
                ) && (
                    <Grid item md={12} xs={12} onClick={!loadingPaymentTypes ? () => setOpenModalPayment(true) : null}
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer', // Para mostrar el cursor de mano al pasar por encima
                        margin: '25px 15px',
                        border: '1px dashed rgb(174, 180, 203)',
                        backgroundColor: paymentData?.payments && paymentData?.payments.length !== 0 ? 'white' : '#f8f8f8',
                        padding: paymentData?.payments && paymentData?.payments.length !== 0 ? '10px' : '20px',
                        borderRadius: 3,
                        boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.1)'
                      }}
                    >
                      <Typography
                        color="primary"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >

                        {/* Cambiar el texto según la condición */}
                        {loadingPaymentTypes ? (
                          <CircularProgress /> // Muestra el circular progress
                        ) : (
                          <>
                            <AddIcon />
                            {paymentData?.payments && paymentData?.payments.length !== 0
                              ? translate('ra.action.addAnotherPaymentRecord')
                              : translate('ra.action.addPaymentRecord')}
                          </>
                        )}

                      </Typography>
                    </Grid>
                  )}

              </>
            )}

            <PaymentModal
              open={openModalPayment}
              handleClose={() => setOpenModalPayment(false)}
              handleSavePayment={handleSavePayment}
              loadingPaymentTypes
              paymentTypes={
                paymentData?.payments && paymentData?.payments.length > 0
                  ? paymentTypes.filter((type) =>
                    ["deposito bancario", "transferencia bancaria"].includes(type.long_name.toLowerCase())
                  )
                  : paymentTypes || []
              }
              banks={banks || []}
              cards={cards || []}
              currencies={
                paymentData?.payments && paymentData?.payments.length > 0
                  ? currencies.filter(currency => currency.id === paymentData.payments[0].currency_info.id)
                  : currencies || []
              }
              cash={cash || []}
              disabledDate={paymentData?.payments && paymentData?.payments[0]?.payment_date && paymentData?.payments[0].payment_date !== '' ? paymentData.payments[0].payment_date : '' || ''}
            />

            <Grid container item>
              {paymentData?.payments && paymentData?.payments.length > 0 && (
                <>
                  {CustomDivider(translate('ra.title.reservationsToPaySelection'))}
                  <TableContainer component={Paper} style={{ border: '1px solid rgb(174, 180, 203)', margin: '15px', boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.1)' }}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                      <TableHead style={{ borderBottom: "1px solid rgba(224, 224, 224, 1)" }}>
                        <TableRow className='cabecera'>
                          <TableCell style={{ width: '10%' }} align="center"><b>{translate('ra.field.reservationNumber')} </b></TableCell>
                          <TableCell style={{ width: '10%' }} align="center"><b> {translate('ra.field.removeReservation')}</b></TableCell>
                          <TableCell style={{ width: '10%' }} align="center"><b> {translate('ra.field.currency')} </b></TableCell>
                          <TableCell style={{ width: '13%' }} align="center"><b> {translate('ra.field.totalAmount')} </b></TableCell>
                          <TableCell style={{ width: '13%' }} align="center"><b> {translate('ra.field.paidAmount')} </b></TableCell>
                          <TableCell style={{ width: '13%' }} align="center"><b> {translate('ra.field.pendingAmount')} </b></TableCell>
                          <TableCell style={{ width: '13%' }} align="center"><b> {translate('ra.field.paymentMethod')} </b></TableCell>
                          <TableCell style={{ width: '13%' }} align="center"><b> {translate('ra.field.amount')} </b></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(paymentData?.reservations_info && paymentData?.reservations_info.flat().length > 0) ? (
                          <>
                            {paymentData?.reservations_info.flat().map((reservation) => (
                              <TableRow key={reservation.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell style={{ width: '10%' }} component="th" scope="row" align="center">
                                  <Box display="flex" alignItems="center" justifyContent="center">
                                    {reservation.number}
                                    <IconButton
                                      onClick={() => handleOpenItems(reservation)}
                                      size="small">
                                      <InfoOutlinedIcon fontSize="small" />
                                    </IconButton>
                                  </Box>
                                </TableCell>
                                <TableCell style={{ width: '10%' }} component="th" scope="row" align="center">
                                  <DeleteOutlineIcon
                                    sx={{ color: '#ee9c2d', cursor: 'pointer' }}
                                    onClick={() => handleDeleteReservation(reservation.id)}
                                  />
                                </TableCell>
                                <TableCell align="center" style={{ width: '10%' }} component="th" scope="row">
                                  <div style={{ paddingBottom: '4px' }}>
                                    {translate('ra.field.reserve')}
                                  </div>
                                  <div style={{ paddingTop: '4px' }}>
                                    {translate('ra.field.payment')}
                                  </div>
                                </TableCell>
                                <TableCell align="center" style={{ width: '14%' }} component="th" scope="row">
                                  <div style={{ paddingBottom: '4px' }}>
                                    {reservation.reservation_prices.origin_currency} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(reservation.reservation_prices.total_amount))}
                                  </div>
                                  <div style={{ paddingTop: '4px' }}>
                                    {reservation.destination_prices.destination_currency} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(reservation.destination_prices.total_amount))}
                                  </div>
                                </TableCell>
                                <TableCell style={{ width: '14%' }} component="th" scope="row" align="center">
                                  <div style={{ paddingBottom: '4px' }}>
                                    {reservation.reservation_prices.origin_currency} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(reservation.reservation_prices.paid_amount))}
                                  </div>
                                  <div style={{ paddingTop: '4px' }}>
                                    {reservation.destination_prices.destination_currency} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(reservation.destination_prices.paid_amount))}
                                  </div>
                                </TableCell>
                                <TableCell style={{ width: '14%' }} component="th" scope="row" align="center">
                                  <div style={{ paddingBottom: '4px' }}>
                                    {reservation.reservation_prices.origin_currency} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(reservation.reservation_prices.pending_amount))}
                                  </div>
                                  <div style={{ paddingTop: '4px' }}>
                                    {reservation.destination_prices.destination_currency} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(reservation.destination_prices.pending_amount))}
                                  </div>
                                </TableCell>
                                <TableCell style={{ width: '14%' }} component="th" scope="row" align="center">
                                  <ToggleButtonGroup
                                    value={reservation.status_payment || 'Total'} // Valor por defecto
                                    onChange={(event, newStatus) => {
                                      handleOptionChangeRadio(reservation.id, newStatus);
                                    }}
                                    exclusive
                                    aria-label="Parcial o Total"
                                    size="small"
                                    color="primary"
                                  >
                                    <ToggleButton value="Total" aria-label="Total" sx={{ textTransform: 'none' }}>
                                      {translate('ra.field.total')}
                                    </ToggleButton>
                                    <ToggleButton value="Parcial" aria-label="Parcial" sx={{ textTransform: 'none' }}>
                                      {translate('ra.field.otherAmount')}
                                    </ToggleButton>
                                  </ToggleButtonGroup>
                                </TableCell>
                                <TableCell style={{ width: '14%' }} align="center">
                                  <CurrencyInput
                                    placeholder="0,00"
                                    type="text"
                                    onChange={(e) => handlePaymentAmountChange(reservation.id, e.target.value)}
                                    value={reservation.payment_amount_display || ''}
                                    error={reservation.error || false}  // Mostrar el error si está presente
                                    disabled={(reservation.status_payment ? (reservation.status_payment === 'Total' ? true : false) : true)}
                                    showAdornment={true} // Muestra el adornment "ARS"
                                    currencySymbol={paymentData?.payments[0]?.currency_info.short_name}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                            <TableRow>
                              <TableCell colSpan={8} align="center" style={{ padding: '10px' }}>
                                <span
                                  onClick={() => setOpenModalReservations(true)}
                                  style={{
                                    cursor: 'pointer',
                                    color: '#5563CD',
                                  }}
                                >
                                  <AddIcon sx={{ marginRight: '5px', verticalAlign: 'middle' }} />
                                  <b> {translate('ra.action.addMoreReservations')} </b>
                                </span>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell colSpan={8} component="th" scope="row" style={{ backgroundColor: 'rgb(234 234 234)' }}>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell colSpan={2} component="th" scope="row" align="right"></TableCell>
                              <TableCell colSpan={2} component="th" scope="row" align="right"></TableCell>
                              <TableCell colSpan={2} component="th" scope="row" align="right">
                                <span> {translate('ra.field.declaredTotal')}: </span>
                              </TableCell>
                              <TableCell colSpan={2} component="th" scope="row" align="right">
                                <span> {paymentData?.payments[0]?.currency_info.short_name} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(totalPayments))}  </span>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell colSpan={2} component="th" scope="row" align="right"></TableCell>
                              <TableCell colSpan={2} component="th" scope="row" align="right"></TableCell>
                              <TableCell colSpan={2} component="th" scope="row" align="right">
                                <span> {translate('ra.field.selectedTotal')}: </span>
                              </TableCell>
                              <TableCell colSpan={2} component="th" scope="row" align="right">
                                <span> {paymentData?.payments[0]?.currency_info.short_name} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(totalReservations))}</span>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell colSpan={2} component="th" scope="row" align="right"></TableCell>
                              <TableCell colSpan={2} component="th" scope="row" align="right"></TableCell>
                              <TableCell colSpan={2} component="th" scope="row" align="right">
                                <span> {translate('ra.field.finalBalance')}: </span>
                              </TableCell>
                              <TableCell colSpan={2} component="th" scope="row" align="right" style={{ color: Math.round(saldo * 100) / 100 !== 0 ? 'red' : 'inherit' }}>
                                <span> {paymentData?.payments[0]?.currency_info.short_name} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(saldo))} </span>
                              </TableCell>
                            </TableRow>
                          </>
                        ) : (
                          <TableRow>
                            <TableCell colSpan={8} align="center" sx={{ lineHeight: "4.43", padding: "20px 0" }}>
                              <span
                                onClick={() => setOpenModalReservations(true)}
                                style={{
                                  cursor: 'pointer',
                                  color: '#5563CD',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                }}
                              >
                                <AddIcon sx={{ marginRight: '5px', verticalAlign: 'middle' }} /> {/* Espacio entre ícono y texto */}
                                <b>{translate('ra.action.addReservations')}</b>
                              </span>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>

                    </Table>
                  </TableContainer>
                </>
              )}
            </Grid>

            <ReservationModal
              open={openModalReservations}
              handleClose={() => setOpenModalReservations(false)}
              handleSaveReservations={handleSaveReservations}
              reservationsList={reservationsList || []}
              business_unit_id={paymentData?.business_unit_info?.id}
              setReservationsList={setReservationsList}
              previousReservations={paymentData?.reservations_info && paymentData?.reservations_info.flat().length > 0 ? paymentData?.reservations_info.flat() : [] || []}
              paymentDateSelected={paymentData?.payments && paymentData?.payments[0]?.payment_date && paymentData?.payments[0].payment_date !== '' ? paymentData.payments[0].payment_date : '' || ''}
              currencySelected={paymentData?.payments && paymentData?.payments[0]?.currency_info.short_name && paymentData?.payments[0].currency_info.short_name !== '' ? paymentData.payments[0].currency_info.short_name : '' || ''}
            />

            <ItemsModal
              open={openModalItems}
              handleClose={() => setOpenModalItems(false)}
              reservation={selectedReservation} // Pasa la reserva seleccionada al modal
            />

            {paymentData?.reservations_info && paymentData?.reservations_info.length > 0 && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', margin: '15px' }}>
                <Button variant="contained" color="primary" size='large' onClick={() => handleConfirmReservations()}>
                  {translate('ra.action.allocatePaymentToReservations')}
                </Button>
              </Box>
            )}

            <ConfirmationModal
              open={openModalConfirmation}
              handleClose={() => setOpenModalConfirmation(false)}
              finalPaymentData={paymentData || []}
              sendForm={sendForm}
              banks={banks || []}
              cards={cards || []}
              currencies={currencies || []}
              cash={cash || []}
              totalDeclared={totalPayments}
              totalSelected={totalReservations}
              finalBalance={Math.round(saldo * 100)/100}
            />

            <Dialog
              open={openModalError}
              onClose={() => setOpenModalError(false)}
              PaperProps={{
                style: {
                  border: '3px solid #e53935',
                  color: '#000',
                  borderRadius: '12px',
                  padding: '24px',
                },
              }}
            >
              <DialogTitle style={{ textAlign: 'center' }}>
                <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                  <ErrorOutlineIcon style={{ color: '#e53935', fontSize: 36 }} />
                  <Typography variant="h6" color="error">
                    Error en el Proceso
                  </Typography>
                </Box>
              </DialogTitle>
              <DialogContent>
                <Typography style={{ whiteSpace: 'pre-line', fontWeight: 500 }}>
                  {errorMessage}
                </Typography>
              </DialogContent>
              <DialogActions style={{ justifyContent: 'center' }}>
                <Button
                  onClick={() => setOpenModalError(false)}
                  variant="contained"
                  style={{ backgroundColor: '#e53935', color: 'white' }}
                >
                  Cerrar
                </Button>
              </DialogActions>
            </Dialog>

          </Form>
        </Create>
      </CardCommon>
    </Container>
  )
}

export default BillingRegister
